import { useTrustsByIds } from '../../query/trusts';
import { UserProfileResponse } from '../../types/authentication';
import { getPatientTrustIds } from '../../utils/patient';
import { UserData } from '../../types/users';

export const usePatientTrusts = (user?: UserProfileResponse | UserData) => {
  const trustIds = user && getPatientTrustIds(user);
  const { data: trusts, isLoading } = useTrustsByIds(trustIds);
  return {
    trusts,
    isLoading,
  };
};
